export const TALK_TO_SALES_SUB_MODALS = {
  CALL_US: 'callUs',
  GET_A_CALL: 'getACall',
  MEETING: 'meeting'
};